// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {createDismissibleBanner} from '../../../pages/Billing/AccountSettings/WarningBanner/DismissibleBanner';
import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../Banner';

// We're doing this for backwards compatibility
// If we just update the banner id to use org and user ids, then
// it will show up again for users that have already dismissed it.
function getRegistryBannerId({
  orgName,
  orgID,
  userName,
  userID,
}: RegistriesInfoBannerProps): string {
  const bannerId = 'global-registry-info:' + orgName + ':' + userName;
  if (bannerId.length <= 64) {
    return bannerId;
  }
  return 'registries-info:' + orgID + ':' + userID;
}

export type RegistriesInfoBannerProps = {
  orgName: string;
  orgID: string;
  userName: string;
  userID: string;
};

export const RegistriesInfoBanner =
  createDismissibleBanner<RegistriesInfoBannerProps>({
    id: ({userID, userName, orgName, orgID}) =>
      getRegistryBannerId({orgName, orgID, userName, userID}),
    Component: ({onDismiss}) => {
      return (
        <Tailwind>
          <div className="pt-24">
            <Banner data-test="registry-info-banner" variant="info">
              <BannerFlexWrapper>
                <div>
                  <Icon name="lightbulb-info" />
                </div>
                <BannerTextWrapper>
                  <span>
                    <BannerBoldText>Welcome to Registry! </BannerBoldText>
                    This is your one-stop destination for all your ML artifacts,
                    including models, datasets, and code, to be shared and
                    utilized across multiple teams within your organization.
                  </span>
                </BannerTextWrapper>
              </BannerFlexWrapper>
              <button
                className="ml-12 flex items-center border-none bg-transparent font-semibold text-moon-800 hover:cursor-pointer hover:text-moon-950"
                onClick={() => {
                  onDismiss();
                }}>
                Dismiss
              </button>
            </Banner>
          </div>
        </Tailwind>
      );
    },
  });
